<button
  [ngStyle]="styles"
  [ngClass]="{
    'button-style-1': typeNumber == 0,
    'button-style-2': typeNumber == 1,
    'cancle-btn': styles?.['class'] === 'cancle-btn'
  }"
  (click)="handleClick()"
  [disabled]="disabled"
>
  <app-spinner *ngIf="loading" [color]="getSpinnerColor()"></app-spinner>
  <span *ngIf="!loading">
    {{ innerText }}
  </span>
</button>
